import * as api from "./api";
import * as modelsGet from "../models/get";
import * as modelsPost from "../models/post";

/**
     * Gibt den Wert einer Einstellung zurück.
     * @param id Der Name der Einstellung dessen Wert zurückgegeben werden soll.
     */
export function getSetting<T>(id: string): JQueryPromise<T>
{
    return api.get<T>({
        endpoint: `api/settings/${id}`
    });
}

export function getSettings(ids?: string[]): JQueryPromise<modelsGet.ISetting[]>
{
    if (ids != null && ids.length > 0)
    {
        return api.get<modelsGet.ISetting[]>({
            endpoint: "api/settings",
            data: {
                ids: ids.join(",")
            }
        });
    }
    else
    {

        return api.get<modelsGet.ISetting[]>({
            endpoint: "api/settings"
        });
    }
}

export function getGeneralSetting<T>(id: string): JQueryPromise<T>
{
    return api.get<T>({
        endpoint: `api/settings/general/${id}`
    });
}

export function getServerSettings(): JQueryPromise<modelsGet.IServerSettings>
{
    return api.get<modelsGet.IServerSettings>({
        endpoint: "api/settings/server"
    });
}

export function getTimezones(): JQueryPromise<modelsGet.ITimezone[]>
{
    return api.get<modelsGet.ITimezone[]>({
        endpoint: "api/settings/timezones"
    });
}

export function getLicence(): JQueryPromise<modelsGet.ILicence>
{
    return api.get<modelsGet.ILicence>({
        endpoint: "api/settings/licence"
    });
}

export function changeLoginHeader(dataUrl: string, type: string): JQueryPromise<any>
{
    return api.put({
        contentType: "application/json",
        endpoint: "api/settings/login/header",
        data: JSON.stringify({
            image: dataUrl,
            type: type
        })
    });
}

export function deleteLoginHeader(): JQueryPromise<any>
{
    return api.remove({
        contentType: "application/json",
        endpoint: "api/settings/login/header"
    });
}

/**
 * Ändert einen vorhandenen Eintrag.
 * @param jsonData Ein JSON-Objekt mit den Daten die gesendet werden sollen.
 */
export function put(settings: modelsPost.ISettings): JQueryPromise<any>
{
    return api.put({
        contentType: "application/json",
        endpoint: "api/settings",
        data: JSON.stringify(settings)
    });
}

export function putLicence(licence: string): JQueryPromise<any>
{
    return api.put({
        contentType: "application/json",
        endpoint: "api/settings/licence",
        data: JSON.stringify({
            licence_key: licence
        })
    });
}

export function putForm(jsonData: any): JQueryPromise<any>
{
    return api.put({
        contentType: "application/json",
        endpoint: "api/settings/form",
        data: JSON.stringify(jsonData)
    });
}

export function putTimeGroups(settings: modelsPost.ITimeGroup[]): JQueryPromise<any>
{
    return api.put({
        contentType: "application/json",
        endpoint: "api/settings/time-group",
        data: JSON.stringify(settings)
    });
}